export default __webpack_public_path__ + "static/media/HeadphoneSidenav.131c9dbe.svg";